var angular = require('angular');
var Sortable = require('sortablejs');

// TODO cancel move on ESC

module.exports = function() {

  return {
    restrict: 'A',

    link: function(scope, element, attrs) {
      var callback = scope[attrs.moveStopLocation];
      var routeId = +attrs.routeId;

      Sortable.create(element[0], {
        group: '' + routeId,
        handle: '.move',
        draggable: '.stop-location',
        animation: 300,
        onEnd: function(event) {
          var id = +event.item.getAttribute('data-stop-location-id');
          var stopLocation = scope.routePlan.findStopLocation(routeId, id);

          callback(stopLocation, event.oldIndex - 1, event.newIndex - 1, routeId);
          scope.$apply();
        }
      });
    }

  };

};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/directives/moveStopLocation.js
 ** module id = 147
 ** module chunks = 1
 **/